import { axiosInstanceV2 } from "./AxiosInstance"

const API_URL = "/modules"

export const getAssignModules = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching assign modules", error)
    throw error
  }
}

export const createAssignModule = async (moduleData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, moduleData)
    return response.data
  } catch (error) {
    console.error("Error creating assign module", {
      error: error.response?.data,
      requestData: moduleData,
    })
    throw error
  }
}

export const updateAssignModule = async (moduleId, moduleData) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${moduleId}`, moduleData)
    return response.data
  } catch (error) {
    console.error("Error updating assign module", error)
    throw error
  }
}

export const deleteAssignModule = async (moduleId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${moduleId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting assign module", error)
    throw error
  }
}

export const getAssignModuleById = async (moduleId) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${moduleId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching assign module details", error)
    throw error
  }
}
